import { Injectable } from '@angular/core';
/*import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';*/
import { HttpRequest,HttpResponse,HttpHeaders, HttpParamsOptions, HttpParams, HttpClient } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import { map, filter, switchMap, catchError } from 'rxjs/operators';
import { Global } from '../Shared/global';
import { IService } from '../Shared/common';

@Injectable()
export class FileUploadService implements IService {
    //constructor(private _http: Http) { }

    headers: HttpHeaders;
    options: {};

  constructor(private _http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'q=0.8;application/json;q=0.9' });
        this.options = { headers: this.headers };
    }

    get(url: string): Observable<any> {
        //return this._http.get(url)
        //    .map((response: Response) => alert(response)) 
        //     //.do(data => Global.Log("All: " + JSON.stringify(data)))
        //    .catch(this.handleError);

        return this._http.get(url).pipe(
            map((response: Response) => alert(response)),
            catchError(<T>(error: any, result?: T) => {
                Global.Log(error);
                return typeof (result as T);
            })
        );
        //<any>response.json()
    }

    getData(url: string): Promise<any> {
        Global.Log(url);
        return this._http
            .get(url, this.options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    post(url: string, model: any): Observable<any> {
        //let body = JSON.stringify(model);
        let body = model;
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        //let headers = new Headers() 
        let options = { headers: headers };
        return this._http.post(url, body, options)
            .pipe(
                map((response: Response) => response),
                catchError(<T>(error: any, result?: T) => {
                    Global.Log(error);
                    return typeof (result as T);
                }));

    }

    postFile(url: string, model: any): Observable<any> {
        //let body = JSON.stringify(model);
        let body = model;
        let headers = new HttpHeaders();
        let options = { headers: headers };
        return this._http.post(url, body, options)
            .pipe(
                map((response: Response) => response),
                catchError(<T>(error: any, result?: T) => {
                    Global.Log(error);
                    return typeof (result as T);
                }));

    }

    put(url: string, id: number, model: any): Observable<any> {
        //let body = JSON.stringify(model);
        let body = model;
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this._http.put(url + id, body, options)
            .pipe(
                map((response: Response) => response),
                catchError(<T>(error: any, result?: T) => {
                    Global.Log(error);
                    return typeof (result as T);
                }));
    }

    delete(url: string, id: any): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers, method: 'DELETE' };
        return this._http.delete(url + id, options)
            .pipe(
                map((response: Response) => response),
                catchError(<T>(error: any, result?: T) => {
                    Global.Log(error);
                    return typeof (result as T);
                }));

    }

    deleteImage(url: string, id: any): Observable<any> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this._http.request("GET", url + id, options)
            .pipe(
                map((response: Response) => response),
                catchError(<T>(error: any, result?: T) => {
                    Global.Log(error);
                    return typeof (result as T);
                }));

    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }

    private handleError(error: any): Promise<any> {
        Global.LogError('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    //private handleError(error: Response) {
    //    debugger
    //    alert(error.json().error);
    //    Global.LogError(error);
    //    return Observable.throw(error.json().error || 'Server error');
    //}

}
